import { http } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function postSuperstepResetOnboardingSession(
  onboardingId
) {
  try {
    const { data } = await http.post('/superstep/onboarding-sessions', {
      reuseData: true,
      onboardingId,
    });

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to reset superstep onboarding session',
      source: 'post-superstep-reset-onboarding-session',
      metadata: {
        onboardingId,
      },
      error: e,
    });
    throw e;
  }
}
